import { render, staticRenderFns } from "./info.vue?vue&type=template&id=f303e8fc&scoped=true&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&id=f303e8fc&prod&lang=scss&scoped=true&"
import style1 from "./info.vue?vue&type=style&index=1&id=f303e8fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f303e8fc",
  null
  
)

export default component.exports